module.exports = __webpack_public_path__ + "static/media/sun.b474cad0.png";